import React from 'react';
import styled from 'styled-components/macro';
import {Card, makeStyles} from '@material-ui/core';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';

export const Row = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: ${(props) => props.justify || 'center'};
    align-items: center;
    background-color: ${(props) => (props.highlight ? '#ffe8e5' : 'white')};
`;

const BoxWrapper = styled.div`
    position: relative;
`;

const BoxCard = styled(Card)`
    margin: 15px 0px 8px 0px;
    padding: ${(props) => (props.withplus === 'true' ? '16px 8px 8px' : '8px')};
    border-radius: 0;
`;

const Title = styled.div`
    position: absolute;
    top: -9px;
    left: 10px;
    background-color: white;
    padding: 0px 4px;
    color: gray;
    font-size: 12px;
`;

const AddButton = styled(Fab)`
    position: absolute;
    top: -8px;
    right: -5px;
    min-height: 22px;
    max-height: 22px;
    min-width: 22px;
    max-width: 22px;
    vertical-align: middle;
    color: gray;
`;

const Box = ({ title, onPlusClicked, children }) => {
        return (
        <BoxWrapper>
            <Title>{title}</Title>
            { onPlusClicked && (
                <AddButton onClick={onPlusClicked}>
                    <AddIcon />
                </AddButton>
            )}
            <BoxCard variant="elevation" elevation={2} withplus={onPlusClicked ? "true" : "false"}>
                {children}
            </BoxCard>
        </BoxWrapper>
    );
};

export default Box;
